import { PayloadAction } from '@reduxjs/toolkit';

import { IFieldChangePayload, IFormsState } from '../../core/interfaces/IFormsState';

export const FormsReducer = {
    setPreIpafForm: (state: IFormsState, action: PayloadAction<any>) => {
        state.pre_ipaf = action.payload;
    },
    setFieldChange: (state: IFormsState, action: PayloadAction<IFieldChangePayload>) => {
        state.field_changes = action.payload;
    },

		restoreDataForms: (state: IFormsState) => {
			state.pre_ipaf = null;
			state.field_changes = null;
		}
}; 
